import clsx from 'clsx';
import styles from './Spinner.module.css';

export interface SpinnerProps {
  readonly size?: number;
  readonly className?: string;
  /** Set when the spinner is the only content, so it is announced. */
  readonly label?: string;
}

export function Spinner({ size = 16, className, label }: SpinnerProps) {
  return (
    <span
      className={clsx(styles.spinner, className)}
      style={{ width: size, height: size }}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
